// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"421a87d5","203":"130b1206","205":"61073c11","238":"031d2011","341":"c7af8ed6","438":"5e17f8e8","560":"ed4c4cce","596":"0c313620","804":"04bf8e8b"}[chunkId] + ".chunk.js";
};